import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faGaugeHigh,
  faHandshake,
  faChartLine,
  faShieldHalved
} from '@fortawesome/free-solid-svg-icons';
import './WhyOurServices.css';

export default function WhyOurServices() {
  const reasons = [
    {
      icon: faGaugeHigh,
      title: 'Sneller resultaat',
      text: 'Door data, tooling en ervaring leveren we merkbaar resultaat in 90 dagen.',
    },
    {
      icon: faHandshake,
      title: 'Één vast aanspreekpunt',
      text: 'Geen losse freelancers maar één team dat alles naadloos voor je regelt.',
    },
    {
      icon: faChartLine,
      title: 'Meetbare groei',
      text: 'Realtime dashboards en maand­rapportages – 100 % transparant.',
    },
    {
      icon: faShieldHalved,
      title: 'Flexibele contracten',
      text: 'Maandelijks opzegbaar of bundel­abonnement voor het scherpste tarief.',
    },
  ];

  return (
    <section className="why-services-section">
      <div className="container">
        <h2 className="why-heading mb-5">Waarom kiezen voor onze diensten?</h2>

        <div className="row g-4">
          {reasons.map(({ icon, title, text }, i) => (
            <div key={i} className="col-12 col-md-6 col-lg-3">
              <div className="reason-card h-100">
                <FontAwesomeIcon icon={icon} size="2x" className="text-orange mb-3" />
                <h3 className="reason-title mb-2">{title}</h3>
                <p className="reason-text mb-0">{text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
